import { _ as _sfc_main } from "./VaConfig.vue_vue_type_script_lang-b032b290.mjs";
import { renderSlot } from "vue";
import { _ as _export_sfc } from "../../../plugin-vue_export-helper-cc2b3d55.mjs";
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return renderSlot(_ctx.$slots, "default");
}
const VaConfig = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  VaConfig as V
};
//# sourceMappingURL=VaConfig-785c45a1.mjs.map
